import axios from "axios";
import { buildQuery } from "utils/queryUtils";

export const findMaritalStatuses = (headers, params) => {
    let query = buildQuery(params, []);
    return axios.get(`${process.env.REACT_APP_CATEGORY_API_URL}/marital-statuses${query}`, {
        headers,
    });
};

export const findMaritalStatusById = (headers, id) => {
    return axios.get(`${process.env.REACT_APP_CATEGORY_API_URL}/marital-statuses/${id}`, {
        headers,
    });
};
